import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown, ChevronUp } from "lucide-react";

const ServiceArea = [
  { label: "Tozkoparan Koltuk Yıkama", path: "/gungoren/tozkoparan-koltuk-yikama" },
  { label: "Tozkoparan Yorgan Yıkama", path: "/gungoren/tozkoparan-yorgan-yikama" },
  { label: "Sanayi Mahallesi Koltuk Yıkama", path: "/gungoren/sanayi-koltuk-yikama" },
  { label: "Sanayi Mahallesi Battaniye Yıkama", path: "/gungoren/sanayi-battaniye-yikama" },
  { label: "Mareşal Çakmak Koltuk Yıkama", path: "/gungoren/maresal-cakmak-koltuk-yikama" },
  { label: "Mareşal Çakmak Perde Yıkama", path: "/gungoren/maresal-cakmak-perde-yikama" },
  { label: "Güven Mahallesi Koltuk Yıkama", path: "/gungoren/guven-koltuk-yikama" },
  { label: "Güven Mahallesi Kuru Temizleme", path: "/gungoren/guven-kuru-temizleme" },
  { label: "Haznedar Koltuk Yıkama", path: "/gungoren/haznedar-koltuk-yikama" },
  { label: "Haznedar Yerinde Yıkama", path: "/gungoren/haznedar-yerinde-yikama" },
  { label: "Güngören Merkez Koltuk Yıkama", path: "/gungoren/merkez-koltuk-yikama" }
];

const GungorenServiceArea = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="text-[#003132] mt-0 w-full">
      <div
        onClick={toggleDropdown}
        className="cursor-pointer flex items-center justify-between bg-[#e2e8f0] p-3 rounded-lg shadow-md hover:bg-[#d1d5db]"
      >
        <h2 className="text-lg font-semibold uppercase tracking-wide">
          GÜNGÖREN HİZMET TÜRLERİ
        </h2>
        {isOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
      </div>

      {isOpen && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-3 bg-[#f1f5f9] p-5 rounded-xl shadow-sm border border-gray-200 w-full mt-2">
          {ServiceArea.map((area, index) => (
            <Link
              key={index}
              to={area.path}
              className={`text-sm font-semibold px-4 py-3 rounded-lg text-center transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-green-700 text-white"
                  : "bg-white text-green-900 hover:bg-green-100 hover:text-green-800"
              }`}
            >
              {area.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default GungorenServiceArea;
